import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { of, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Lang, ReferenceParams, UploadFile } from 'src/app/models';
import { ApiAttributesMappingService, ApiOrganizationsService, FilesService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-product-data-upload',
  templateUrl: './product-data-upload.component.html',
  styleUrls: ['./product-data-upload.component.css']
})
export class ProductDataUploadComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  result: any;
  mappingId: string;
  errorMessages: any;
  loading: boolean;
  mappingSets: any;
  currentOrg: any;
  currentLang:any;
  file: any;
  lang: any = [
    {
      id:'ru',
      name:'Русский'
    },
    {
      id:'en',
      name:'Английский'
    },
    {
      id:'kk',
      name:'Казахский'
    }
  ]

  fileUploadObject: UploadFile = {
    data: null,
    inProgress: false,
    progress: 0,
    error: false,
    uploaded: false
  }

  form: UntypedFormGroup = this.fb.group({
    mapping_id: [null],
    lang:[null]
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private apiAttrsMappingService: ApiAttributesMappingService,
    private notification: NotificationService,
    private fileService: FilesService,
    private apiOrganizations: ApiOrganizationsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.subscriptions.add(
      this.form.get('mapping_id').valueChanges.subscribe(val => {

        this.mappingId = val;
      })
    )

    this.subscriptions.add(
      this.form.get('lang').valueChanges.subscribe(val => {

        this.currentLang = val;
      })
    )

    this.subscriptions.add(
      this.apiOrganizations.listenerCurrentOrganization().subscribe(val => {

        this.currentOrg = val;
      })
    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.getMappingSets();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getMappingSets(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes_mapping_sets',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRIBUTES LIST: ", response);


        if (response != null) {

          this.mappingSets = response.result;

        }
      })
    );

  }

  /**
   * 
   * @param systemId 
   * @param files 
   */
  onSelectedFiles(files: any = []): void {

    if (files.length == 0) return;

    this.file = files[0];

    this.fileUploadObject.data = files[0];
  }

  /**
   * 
   * @param file 
   * @param system_id 
   */
  uploadFile(): void {

    const formData = new FormData();
    let methodName: string = 'importFile';

    formData.append('file', this.fileUploadObject.data);
    formData.append('org_id', this.currentOrg.id);
    formData.append('mapping_id', this.mappingId);
    formData.append('lang', this.currentLang);

    console.log(formData.get('org_id'), formData.get('mapping_id'), formData.get('lang'));


    this.fileUploadObject.inProgress = true;

    console.log("FILE DATA: ", this.fileUploadObject.data)

    this.fileService.upload(methodName, formData).pipe(
      map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.fileUploadObject.progress = Math.round(event.loaded * 100 / event.total);

            break;
          case HttpEventType.Response:
            return event;
        }
      }),
      catchError((error: HttpErrorResponse) => {

        this.fileUploadObject.inProgress = false;
        this.fileUploadObject.error = true;

        this.notification.show('danger', 'Загрузка файла ' + this.fileUploadObject.data.name + ' не удалась.');

        return of('Загрузка файла ' + this.fileUploadObject.data.name + ' не удалась.');

      })).subscribe((event: any) => {

        if (typeof (event) === 'object') {

          setTimeout(() => {

            console.log('[UPLOAD FILE]: ', event);

            if (event.body == null) return;

            this.fileUploadObject.inProgress = false;
            this.fileUploadObject.uploaded = true;

            this.result = event.body;

            this.notification.show('success', 'Загрузка файла выполнена успешно!');

            this.fileUploadObject.data = null;

            this.activeModal.close(true);

          }, 2000)
        }
      }
      );
  }

  /**
   * DOWNLOAD FILE
   * @param file
   */
  downloadFile(): void {

    this.fileService.downloadMappingTemplateExpamleFile(this.mappingId, this.mappingSets.find(val => val.id == this.form.get('mapping_id').value).name);
  }

  /**
   * 
   */
  deleteFile() {

    this.file = null;
  }

}
